import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">分类浏览</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按类型探索，找到你最爱的韩漫风格</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 hover:bg-background-50 transition-all cursor-pointer border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-label">
                <span>{cat.comicIds.length} 部作品</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}